
export const touchOnlyDevice = '@media (hover: none)'
export const mouseDevice = '@media (hover: hover)'